import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles(({ spacing, palette, typography, variables }: Theme) => ({
    jetSegmentedControllerContainer:{
        backgroundColor:palette.jet?.containerStrong,
        height:'48px',
        borderRadius:variables?.radiusRoundedE,
        display:'flex',
        '& .control':{
            cursor:'pointer',
            borderRadius:variables?.radiusRoundedE,
            flexGrow: 1,
            flexBasis: 0,
            minWidth: 0,
            alignItems:'center',
            justifyContent:'center',
            fontSize:typography?.button?.buttonSSize?.fontSize,
            lineHeight:typography?.button?.buttonSSize?.lineHeight,
            userSelect:'none',
            marginRight:'2px',
            '& .innerWrapper':{
                borderRadius:variables?.radiusRoundedE,
                height:'100%',
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                textAlign:'center',
                paddingLeft:variables?.spacingB,
                paddingRight:variables?.spacingB
            },
            '&:active':{
                backgroundColor: `rgba(0,0,0,${palette.jet?.active01})`
            },
            '&:focus':{
               outline:`2px solid ${palette.jet?.focusOuter}`
            },
            '&:hover':{
                '& .innerWrapper':{
                    backgroundColor: `rgba(0,0,0,${palette.jet?.hover01})`
                }
            },
            '&.active':{
                backgroundColor:palette.jet?.interactiveLight,
                boxShadow:variables?.elevation02,
                fontWeight:variables?.fontWeightBold,
            },
            '&.disabled':{
                backgroundColor:palette.jet?.containerStrong,
                color:palette.jet?.contentDisabled,
                pointerEvents:'none',
                boxShadow:`none`,
            }
        }
    }
}))


export default styles